import { Bookpage, ImageQuality, SlideType } from '@pcp/core/interfaces';
import { IDisplaySlide } from '@pcp/core/interfaces';
import { v1 } from 'uuid';

/**
 * Create a transient display-side IDisplaySlide from a bookpage record.
 * Used by BookpageSignals to construct slide objects for navigation.
 */
export const createBookpageDisplaySlide = (bookpage: Bookpage): IDisplaySlide => ({
    id: 0,
    type: SlideType.bookpage,
    moduleId: 0,
    versionId: 0,
    caption: '',
    imageVariants: {
        [ImageQuality.LOW]: bookpage.imageResource,
        [ImageQuality.MEDIUM]: bookpage.imageResource,
        [ImageQuality.HIGH]: bookpage.imageResource,
    },
    imageResource: bookpage.imageResource,
    previewpicture: {
        thumb_n: bookpage.imageResource,
        thumb_h: bookpage.imageResource,
    },
    hideFavoriteButton: true,
    parentId: 0,
    showCaption: false,
    vimeoVideoId: null,
    bookpageNo: bookpage.page,
    panorama: bookpage.panorama,
    guid: v1(),
    questionModuleType: null,
});
